import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles'


export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: '0px 0px',
      width: '100%',
      padding: '.2rem'
    },
    label: {
      minWidth: '86px'
    },
    rightSeparation: {
      marginRight: '8px'
    },
    itemTitle: {
      gridArea: 'itemTitle',
      alignItems: 'flex-start !important'
    },
    header: {
      width: '100%',
      justifyContent: 'space-between'
    },
    ref: {
      color: '#847848',
      fontFamily: 'NextArtHeavy',
      marginRight: '.2rem'
    },
    quantityTitle: {
      fontSize: 14,
      color: '#6D6A6F',
      display: 'flex',
      fontWeight: 900,
      gap: '.3rem',
      // marginBottom: '.4rem',
      // position: 'absolute',
      left: '.5rem',
      bottom: '.3rem',
      alignItems: 'center',
      marginTop: '.3rem',
      '@global': {
        '.MuiTypography-root': {
          fontSize: 14,
        }
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: '0',
      }
    },
    listItem: {
      display: 'flex',
      justifyContent: 'flex-start !important',
      alignItems: 'flex-start',
      flexDirection: 'row',
      gap: '.5rem',
      borderTopLeftRadius: '8px !important',
      borderTopRightRadius: '8px !important',
      height: 'fit-content',
      padding: '0.35rem !important',
      border: '2px solid #F5F6F7',
      borderRadius: 8,
      boxShadow: '0px 3px 5px rgba(26, 42, 85, 0.2), 0px 0px 1px rgba(26, 42, 85, 0.31)',
      '&:before': {
        display: 'none'
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'row-reverse'
      }        // margin: '.5rem 0 0'
    },
    img: {
      color: '#9D9B9F',
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
    },
    imgIcon: {
      fontSize: '1rem'
    },
    button: {
      color: '#2F7BF7 !important',
      textTransform: 'none',
      fontWeight: "700 !important",
      backgroundColor: '#FCFCFC !important',
      boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 1px rgba(26, 42, 85, 0.31) !important',
      borderRadius: "8px !important",
      height: "40px !important",
    },
    item: {
      color: 'var(--head-text-color) !important',
      fontFamily: 'LatoBlack !important',
      fontWeight: "900 !important",
      fontSize: '16px !important',
      lineHeight: '24px !important'
    },
    itemDesc: {
      color: 'var(--input-color) !important',
      fontFamily: 'LatoNormal !important',
      fontWeight: "400 !important",
      fontSize: '14px !important',
      lineHeight: '22px !important',
      margin: '1px 0px 0px 2px !important'
    },
    itemType: {
      color: 'var(--head-text-color) !important',
      fontFamily: 'LatoNormal !important',
      fontWeight: "500 !important",
      fontSize: '16px !important',
      lineHeight: '24px !important',
      margin: '5px 0px 0px 0px !important'
    },
    itemEnd: {
      color: 'var(--head-text-color) !important',
      fontFamily: 'LatoNormal !important',
      fontWeight: "500 !important",
      fontSize: '16px !important',
      lineHeight: '24px !important',
      alignSelf: 'flex-end !important',
      marginRight: '12px !important'
      // maxWidth: '100px'
    },
    row: {
      display: 'flex !important',
      flexDirection: 'row',
      alignItems: 'center !important',
      // gap: '2px',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start !important'
      }
    },
    column: {
      display: 'flex !important',
      flexDirection: 'column'
    },
    price: {
      fontFamily: 'NextArtBold !important',
      // fontSize: '16px',
      color: '#0B060F !important',
      gridArea: 'price',
      justifySelf: 'flex-end !important',
      whiteSpace: 'nowrap'
    },
    /* price: {
      fontFamily: 'NextArtBold',
      fontSize: '16px',
      color: '#0B060F',
      gridArea: 'price',
      justifySelf: 'flex-end',
      whiteSpace: 'nowrap'
    }, */
    icon: {
      // color: 'var(--head-text-color)',
      // margin: '18px 8px',
      fontSize: '1rem !important'
    },
    expand: {
      fontSize: '1rem !important',
      backgroundColor: '#F5F6F7 !important',
      borderRadius: '2px !important',
      width: '1.5rem !important',
      height: '1.5rem !important'
    },
    /*  expandBox: {
       display: 'flex',
       width: '26px',
       height: '26px',
       borderRadius: '4px',
       backgroundColor: 'var(--bosscat-blue-600)',
       justifyContent: 'center',
       alignItems: 'center',
       '&:hover': {
         backgroundColor: 'var(--button-focus-color)',
         borderColor: 'var(--button-focus-color)',
         boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 1px rgba(26, 42, 85, 0.31)'
       }
     }, */
    itemPercent: {
      fontFamily: 'LatoNormal !important',
      fontWeight: '500 !important',
      fontSize: '16px !important',
      lineHeight: '24px !important',
      color: 'var(--white-color) !important'
    },
    descr: {
      // fontFamily: 'LatoNormal',
      fontSize: '14px !important',
      marginTop: '.3rem !important'
      // margin: '4px 10px 0px 10px'
    },
    container: {
      width: '100% !important',
      // padding: '.5rem',
      // backgroundColor: 'var(--background-color-secondary)',
      zIndex: 9,
      // border: '2px solid #F5F6F7',
      // borderRadius: 8,
      // boxShadow: '0px 3px 5px rgba(26, 42, 85, 0.2), 0px 0px 0px rgba(26, 42, 85, 0.31)',
      // borderTopLeftRadius: '0px',
      // borderTopRightRadius: '0px',
      borderTop: 0,
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        boxShadow: 'none',
      }
    },
    image: {
      margin: '6px 0px 4px 0px'
    },
    buttonRemove: {
      width: '220px !important',
      height: '45px !important',
      textTransform: 'none',
      color: 'var(--white-color) !important',
      backgroundColor: 'var(--delete-button-color) !important',
      borderRadius: "8px !important",
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
        height: '40px !important'
      },
      margin: '5px !important',
      '&:hover': {
        backgroundColor: 'var(--expired-color) !important'
      },
    },
    buttonAdd: {
      width: '220px !important',
      height: '45px !important',
      textTransform: 'none',
      color: 'var(--white-color) !important',
      backgroundColor: 'var(--bosscat-green-600) !important',
      borderRadius: "8px !important",
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
        height: '54px !important'
      },
      margin: '5px !important',
      '&:hover': {
        backgroundColor: 'var(--bosscat-green-700) !important'
      },
    },
    buttonClose: {
      width: '220px !important',
      height: '45px !important',
      textTransform: 'none',
      color: 'var(--bosscat-blue-600) !important',
      backgroundColor: 'white !important',
      borderRadius: 8,
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
        height: '40px !important'
      },
      margin: '5px !important',
      '&:hover': {
        backgroundColor: '#1A2A55 !important'
      }
    },
    buttonContent: {
      justifyContent: 'flex-end !important'
    },
    containerBox: {
      display: 'flex !important',
      width: 'fit-content !important',
      flexDirection: 'column',
      margin: '.5rem 0 !important'
    },
    italic: {
      fontStyle: 'italic !important',
    },
    title: {
      fontStyle: 'inherit !important',
    },
    alert: {
      position: 'absolute',
      // zIndex: 1,
      // flex: 1, justifyContent: 'flex-end', // bottom: 0,
      width: '100% !important',
      height: 'auto !important',
      backgroundColor: 'var(--white-color) !important',
      border: '2px solid var(--border-color) !important',
      borderRadius: '16px 16px 0px 0px !important',
      padding: '20px !important',

      display: 'flex !important',
      flexDirection: 'column',
      // position: 'sticky',
      bottom: "0px !important",
      zIndex: 9
    },
    bold: {
      fontWeight: "900 !important",
      display: 'inline'
    },
    flexStart: {
      alignItems: 'flex-start !important'
    },
    contentItem: {
      display: 'flex',
      gap: '.5rem',

      '@global': {
        '.MuiTypography-root': {
          //fontSize: '16px !important',
          display: 'inline',
          [theme.breakpoints.down('sm')]: {
            fontSize: '14px !important',
          }
        }
      }
    },
    content: {
      margin: "1rem 0 !important",
      gap: '.5rem !important',
      [theme.breakpoints.down('sm')]: {
        margin: '0 !important'
      }
    },
    actionButton: {
      minHeight: '40px !important',
      gap: '.5rem !important',
      gridArea: 'button',
      justifySelf: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      }
    },
    left: {},
    right: {},
    inspectionTitle: {
      fontFamily: 'NextArtBold !important',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    inspectionImg: {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    inspectionTitleContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    itemImage: {
      width: 41
    },
    quantityContainer: {
      gap: '1rem',
      gridArea: 'quantity',
    },
    itemHeader: {
      gap: '0.5rem',
      height: 'fit-content',
      display: 'flex',
      // padding: '0.35rem !important',
      justifyContent: 'space-between !important',
      width: '100%',
      alignItems: 'flex-start',

      [theme.breakpoints.down('sm')]: {
        display: 'grid',
        boxShadow: 'none',
        gridTemplateAreas: "'itemTitle price' 'button button'",
        // gridTemplateColumns: '75%',
      },
    },
    itemContainer: {
      width: '100%',
      alignItems: 'flex-start'
    },
    expandIcon: {
      marginTop: '.3rem'
    },
    alignCenter: {
      alignItems: 'center'
    },
    itemHeaderLeft: {
      width: '77% !important',
      [theme.breakpoints.down('sm')]: {
        width: '100% !important',
      }
    }
  })
)
